import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';
import FadeInSection from './FadeInSection';
import getCanonicalUrl from '../utils/getCanonicalUrl';

const Contact = () => {
  const [formData, setFormData] = useState({
    message: '',
    name: '',
    kana: '',
    phone: '',
    email: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const canonicalUrl = getCanonicalUrl('https://gokurakuji-kinokawa.com/contact');
  const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/d/e/1FAIpQLSc0nd697FyK-fJH-dI_PhiK7GuxxzMixbVH2G-NYfh8wmjagQ/formResponse';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = new URLSearchParams();
      payload.append('entry.1929026708', formData.message); // お問い合わせ内容
      payload.append('entry.1561759071', formData.name); // 名前
      payload.append('entry.1253454335', formData.kana); // カナ
      payload.append('entry.702351013', formData.phone); // 電話番号
      payload.append('entry.1522481000', formData.email); // メールアドレス

      await fetch(GOOGLE_FORM_ACTION, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: payload.toString()
      });

      setSubmitted(true);
      setError(null);
      setFormData({
        message: '',
        name: '',
        kana: '',
        phone: '',
        email: ''
      });
    } catch (err) {
      setError('送信中にエラーが発生しました。再度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };



  if (submitted) {
    return (
      <div className="contact-page">
        <Helmet>
          <title>お問い合わせ完了 | 安養山極楽寺</title>
          <meta
            name="description"
            content="お問い合わせありがとうございました。担当者より追ってご連絡いたします。"
          />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="安養山極楽寺" />
          <meta property="og:title" content="お問い合わせ完了 | 安養山極楽寺" />
          <meta
            property="og:description"
            content="お問い合わせありがとうございました。内容を確認のうえ、担当者よりご連絡いたします。"
          />
          <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/main_contact.jpeg`} />
          <meta property="og:url" content={canonicalUrl} />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
        <FadeInSection>
          <h2 className="section-title">送信完了</h2>
          <hr className="section-divider" />
          <p>お問い合わせありがとうございました。内容を確認の上、ご連絡いたします。</p>
        </FadeInSection>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <Helmet>
        <title>お問い合わせ | 安養山極楽寺</title>
        <meta
          name="description"
          content="ご供養や法要、霊園、お墓に関するご相談・お問い合わせはこちらから。フォームに必要事項をご記入のうえ送信してください。"
        />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="安養山極楽寺" />
        <meta property="og:title" content="お問い合わせ | 安養山極楽寺" />
        <meta
          property="og:description"
          content="安養山極楽寺へのお問い合わせフォーム。ご供養・永代供養やお墓、イベントについてお気軽にご相談ください。"
        />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/main_contact.jpeg`} />
        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <FadeInSection>
        <h2 className="section-title">お問い合わせ</h2>
        <hr className="section-divider" />
        {error && <p className="error-message" style={{color: 'red'}}>{error}</p>}
      </FadeInSection>

      <FadeInSection>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label>
              お問い合わせ内容 <span className="required">※必須</span>
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
            />
          </div>

          <div className="form-group">
            <label>
              名前 <span className="required">※必須</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>
              名前（カナ）
            </label>
            <input
              type="text"
              name="kana"
              value={formData.kana}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>
              電話番号<span className="required">※必須</span>
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>メールアドレス</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <p className="required-note">
            必須事項を入力の上、送信してください。
          </p>
          <p className="contact-note" style={{fontSize: '14px', color: '#666', marginBottom: '20px', lineHeight: '1.6'}}>
            お問い合わせは内容を確認のうえ、順次対応させていただきますが、ご返信までにお時間をいただく場合がございます。あらかじめご了承ください。
          </p>
          <button type="submit" className="submit-button" disabled={isSubmitting}>
            {isSubmitting ? '送信中…' : '送信する'}
          </button>
        </form>
      </FadeInSection>
    </div>
  );
};

export default Contact;
